var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.67969 3.92969 2.32031 2.32031h-7.5v-1.875c0-.16576.06585-.32473.18306-.44194s.27618-.18306.44194-.18306h4.11719c.08115-.00028.16157.01544.23664.04628.07507.03083.14333.07617.20086.13341z",
    fill: "#4d4d4d",
    opacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.9453 16.25h-13.86717c-.07593 0-.1511-.015-.22124-.044-.07015-.0291-.13388-.0716-.18756-.1253-.05369-.0537-.09627-.1174-.12532-.1876-.02906-.0701-.04401-.1453-.04401-.2212v-9.4219h14.375c.1658 0 .3247.06585.4419.18306.1173.11721.1831.27618.1831.44194v8.8203c0 .1471-.0584.2882-.1625.3922-.104.1041-.2451.1625-.3922.1625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5 6.25v-1.875c0-.16576.06585-.32473.18306-.44194s.27618-.18306.44194-.18306h4.11719c.08115-.00028.16157.01544.23664.04628.07507.03083.14333.07617.20086.13341l2.32031 2.32031"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFolder);
export default __webpack_public_path__ + "static/media/file-folder.16b25624b8dce446283e642516a79651.svg";
export { ForwardRef as ReactComponent };